<template>
    <div class="app-container">
        <el-card class="search-form-card">

            <el-form ref="form" :inline="true" :model="form" class="search-form">

                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" ></el-input>

                </el-form-item>
                <el-form-item label="分类:" >
                    <el-cascader  ref='category' :props="category" clearable v-model="categoryObj" :show-all-levels="false" props.checkStrictly=true
                                 @change="showSelect"
                    >
                        <template slot-scope="{ node, data }">
                            <span>{{ data.label }}</span>
                        </template>
                    </el-cascader>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>

        </el-card>

        <el-card>
            <div slot="header" class='project_head'>

                <router-link :to="{ path:'/configurationUpdata', query: { callback:request } }">
                    <el-button type="primary">新增配置项</el-button>
                </router-link>

                <!-- <div :class='isShowTree? "tree hoverActive" : "tree" '
                 @mouseover='isShowTree = true'
                 @mouseout='isShowTree = false'>
                    <span>{{ title }}</span>
                    <div class="voiture-container" v-show="isShowTree">
                        <el-tree :props="props" :load="loadNode" lazy highlight-current accordion :expand-on-click-node='false' v-loading='treeLoading'>
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span @click='nodeClick(data)'>{{ node.data.title }}</span>
                            </span>
                        </el-tree>
                    </div>
                </div> -->

            </div>

            <el-table :data="tableData" stripe v-loading='loading'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="配置项编号" prop="serialNumber"></el-table-column>

                <el-table-column label="配置项名称" prop="title"></el-table-column>

                <el-table-column label="配置项分类" prop="category"></el-table-column>

                <el-table-column label="配置项状态">
                    <template slot-scope='scope'>
                        {{ scope.row.status | tableVal(cmdbStatus) }}
                    </template>
                </el-table-column>

                <el-table-column label="创建时间" prop="createTime" ></el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <router-link :to="{ path:'/configurationUpdata', query: { callback:request, type: 'edit', serialNumber:scope.row.serialNumber } }">
                            <el-button type='text'>编辑</el-button>
                        </router-link>
                        <router-link :to="{ path:'/configurationDetail', query: { serialNumber:scope.row.serialNumber, callback: request } }">
                            <el-button type='text'>详情</el-button>
                        </router-link>
                        <el-button
                            class="table-del-btn"
                            @click.native.prevent="deleteRow(scope.$index, tableData, scope.row.serialNumber)"
                            type="text"
                            plain
                            v-w-role="'ITSM-0061'"
                        >删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页器 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20, 30, 40]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>

    </div>
</template>

<script>
import services from "./configuration.services"
import sendServices from './configuration.services'
export default {

    data() {
        return {
            form: {
                pageSize: 10,
                pageIndex: 1,
                keyword: ""
            },
            total: 0,
            tableData: [],
            pageSizes: [10, 20, 30, 40],
            loading: true,
            treeLoading: true,
            // isShowTree: true,
            title: "配置项分类",
            props: {
                label: "name",
                children: "zones",
                isLeaf: "leaf"
            },
            categoryObj:{},
            category: {
                lazy: true,
                checkStrictly: true,
                lazyLoad: (node, resolve) => this.categoryLazyLoad(node, resolve)
            },
        };
    },

    computed: {
        dictionary() {
            return this.$store.state.dictionary
        },
        cmdbStatus() {
            return this.dictionary.cmdb_status
        }
    },

    mounted() {
        this.request()
    },

    methods: {

        // 点击查找分类列表
        // nodeClick(data) {
        //     this.form.category = data.id
        //     this.request({ category: data.id })
        // },

        // 请求数据查找子项
        loadNode(node, resolve) {
            if (node.level === 0) {
                services.typeList({ type: 11 }).then(res => {
                let newArr = res.map(item => ({
                    id: item.id,
                    title: item.title,
                    leaf: !item.hasChildren
                }))
                resolve(newArr)
                this.treeLoading = false
                })
            } else {
                services.childrenList({ parentId: node.data.id }).then(res => {
                    let newArr = res.map(item => ({
                        id: item.id,
                        title: item.title,
                        leaf: !item.hasChildren
                    }))
                    resolve(newArr);
                    this.treeLoading = false
                })
            }
        },
        showSelect(obj){
            // console.log(obj)
            // this.showConfigPros=false
            // this.form.category = this.categoryObj[0].id
            obj[0] ? this.form.category = obj[obj.length-1].id : this.form.category = null
            // let getCategory=this.form.category[this.form.category.length-1]
            // if (getCategory&&getCategory.title.indexOf('服务器')>-1){
            //             this.showConfigPros=true
            // }
        },
        // 分类懒加载请求
        categoryLazyLoad(node, resolve) {
            if (!node.level) {
                sendServices.typeList({ type: 11 }).then(res => {
                let newArr = res.map(item => {
                    return {
                    leaf: !item.hasChildren,
                    value: item,
                    label: item.title
                    };
                });
                resolve(newArr);
                });
            } else {
                sendServices.childrenList({ parentId: node.value.id }).then(res => {
                let newArr = res.map(item => ({
                    leaf: !item.hasChildren,
                    value: item,
                    label: item.title
                    }));
                resolve(newArr);
                });
            }
        },
        loadData(){
            this.form.pageIndex=1
            this.request()
        },
        // 获取列表数据
        request(params) {
            if (params) params = { ...params, ...this.form }
            this.tableData = []
            this.loading = true
            services.cmdbLlist(params || this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = +res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => (this.loading = false))
        },

        // 删除列表某一项
        deleteRow(index, rows, serialNumber) {
            this.$confirm("此操作将永久删除该合同, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                services
                    .cmdbdDelete({ serialNumber: serialNumber })
                    .then(res => {
                        this.$message.success("删除成功!")
                        rows.splice(index, 1)
                        this.request()
                    })
                    .catch(err => this.$message.error(err.message))
                })
            .catch(() => this.$message.info("已取消删除"))
        },

        // 更新分页器页数
        handleSizeChange(val) {
            let pages = Math.ceil(this.total / val)
            this.form.pageSize = val
            if (this.form.pageIndex > pages) {
                this.form.pageIndex = 1
            }
            this.request()
        },

        // 更新分页器页码
        handleCurrentChange(val) {
            this.form.pageIndex = val
            this.request()
        }
    }
};
</script>

<style lang="scss" scoped>
.project_head {
  position: relative;
  .tree {
    width: 150px;
    position: absolute;
    top: 5px;
    right: 0;
    z-index: 1000;
    .voiture-container {
      height: 200px;
      overflow: hidden;
      overflow-y: auto;
      backface-visibility: hidden;
    }
  }
  > div.hoverActive {
    background: #fff;
  }
}
</style>

